/* eslint camelcase: 0 */
import { MonitaroGatewayBase } from './base'
import { toAppointmentProps, toAppointmentRequest } from './translator/appointment'
import { toQuery, toQueryProps } from './translator/query'
import { EmptyResponsePropsFactory } from '@/entities/Response'
import { IQueryProps } from '@/entities/Query'
import {
  FetchAppointment,
  FetchSchedule,
  PostAppointment,
  GetAppointment,
  PutAppointment,
  DeleteAppointment
} from '@/infrastructure/network/Monitaro/requests/appointment'
import { IAppointmentProps } from '@/entities/Appointment'

export default class Appointment extends MonitaroGatewayBase {
  async FetchAppointment(query?: IQueryProps) {
    const response = await this.apiClient.request(new FetchAppointment(toQuery(query)))
    return EmptyResponsePropsFactory({
      items: response.appointments.map((prop) => toAppointmentProps(prop)),
      query: toQueryProps(response.query)
    })
  }

  async FetchSchedule(query?: IQueryProps) {
    const response = await this.apiClient.request(new FetchSchedule(toQuery(query)))
    return EmptyResponsePropsFactory({
      items: response.appointments.map((prop) => toAppointmentProps(prop)),
      query: toQueryProps(response.query)
    })
  }

  async PostAppointment(params: IAppointmentProps) {
    const { appointment } = await this.apiClient.request(new PostAppointment(toAppointmentRequest(params)))
    return toAppointmentProps(appointment)
  }

  async GetAppointment(id: string) {
    const { appointment } = await this.apiClient.request(new GetAppointment(id))
    return toAppointmentProps(appointment)
  }

  async PutAppointment(id: string, params: IAppointmentProps) {
    const { appointment } = await this.apiClient.request(new PutAppointment(id, toAppointmentRequest(params)))
    return toAppointmentProps(appointment)
  }

  async DeleteAppointment(id: string, target?: 'result' | 'schedule') {
    const response = await this.apiClient.request(new DeleteAppointment(id, target))
    return response
  }
}
